// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__25sJ6","label":"Completed_label__SnnLO"};